// 系统语言环境设置 (cn 中文版；en 英文版)
const env = 'en';
export default env;


// WEBPACK FOOTER //
// ./src/config/dev.js